// 同一个应用页面唯一的id
// 主要为了配合@yld/yun-table-list的configType(需要唯一性)
const pageId = {
  // 员工管理
  'staffIndex': 1,
  //  分公司管理
  'branchIndex': 2,
  // 角色管理
  'roleManage': 3,
  // 数据管理权限
  'dataAuth': 4,
  // 临时代班
  'fillInList': 5,
  // 离职交接
  'leaveList': 6
}

export {
  pageId
}
